import React, { FC, ReactNode, useContext } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { ComplianceBackgroundCheckIcon } from '@fiverr-private/visuals';
import { ComplianceContext } from '../ComplianceProvider';
import { ComplianceType, ComplianceTypes } from '../ComplianceModal/types';
import { reportEventsApi } from '../../biEvents';

export const BackgroundCheckSection = (
    isEligibleForBackgroundCheck: boolean,
    requeseteeId: number
):
    | {
          icon: React.ReactNode;
          complianceType: ComplianceType;
          Wrapper: FC<{
              children: ReactNode;
          }>;
      }[]
    | [] => {
    const complianceContext = useContext(ComplianceContext);

    if (!isEligibleForBackgroundCheck) {
        return [];
    }
    return [
        {
            icon: <ComplianceBackgroundCheckIcon size={'md'} color={'grey_1200'} />,
            complianceType: ComplianceTypes.BACKGROUND_CHECK,
            Wrapper: ({ children }: { children: React.ReactNode }) => (
                <Stack
                    display="flex"
                    width="100%"
                    onClick={() => {
                        reportEventsApi.clickedOnBackgroundCheck({
                            pageName: complianceContext?.pageName ?? '',
                            sellerId: requeseteeId,
                            type: 'section',
                        });
                    }}
                >
                    {children}
                </Stack>
            ),
        },
    ];
};
